export default "__VITE_ASSET__BfpkkYY2__"